"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findInvalidSocialNetworkLinks = void 0;
const enums_1 = require("../enums");
const social_links_instance_1 = require("./social-links-instance");
const socialLinks = (0, social_links_instance_1.getSocialLinksInstance)();
const ALLOWED_PROFILE_NAMES = Object.values(enums_1.SocialNetwork);
const findInvalidSocialNetworkLinks = (value) => {
    if (!value) {
        return [];
    }
    const notAllowedProfileNames = Object.keys(value).filter((key) => !ALLOWED_PROFILE_NAMES.includes(key));
    if (notAllowedProfileNames.length) {
        return notAllowedProfileNames;
    }
    const validProfileNames = Object.entries(value)
        .filter(([profileName, link]) => {
        if (!link) {
            return false;
        }
        return socialLinks.isValid(profileName, link);
    })
        .map(([profileName]) => profileName);
    return Object.keys(value).filter((profileName) => !validProfileNames.includes(profileName));
};
exports.findInvalidSocialNetworkLinks = findInvalidSocialNetworkLinks;
//# sourceMappingURL=find-invalid-social-network-links.validator.js.map